import { FC } from "react";

/**
 * The pointer under a tooltip bubble — a triangle whose apex is rounded to match
 * the bubble's corner radius. Decorative; size and colour come from the wrapper.
 */
export const IconTooltipTip: FC = () => (
  <svg viewBox="0 0 16 7.336" fill="currentColor" aria-hidden="true">
    <path d="M9.43156 6.73265C8.64672 7.53712 7.35328 7.53712 6.56844 6.73265L0 0L16 1.14614e-06L9.43156 6.73265Z" />
  </svg>
);

export default IconTooltipTip;
